<template>
  <div class="product-container pt-5 position-relative vw-100">
    <transition
        appear
        v-bind:css="false"
        v-on:before-enter="actions.beforeEnterModal"
        v-on:enter="actions.enterModal"
        v-on:leave="actions.leaveModal"
    >


      <div class="product-instructions">
        <LocalizedLink to="/" class="close-detail position-absolute"></LocalizedLink>
        <arrow key="arrowleft" arrow-class="arrow-left" target="/audio-adventure"></arrow>
        <arrow key="arrowright" arrow-class="arrow-right" target="/video"></arrow>
        <div class="product-copy-container">
          <transition name="bounce">
            <div v-if="show">
              <div class="product-title">
                <div class="product-num">5</div>
                <div class="product-name" v-html="$t('safety_screen.title')"></div>
              </div>
              <div class="product-inst" v-html="$t('safety_screen.content')"></div>
            </div>
          </transition>
        </div>
      </div>

    </transition>
    <transition
        appear
        v-bind:css="false"
        v-on:before-enter="actions.beforeEnterProduct"
        v-on:enter="actions.enterProduct"
        v-on:leave="actions.leaveProduct"
    >
      <div class="product-detail position-absolute">
        <div class="detail-inner">
        <!-- <picture>
          <source media="(max-width: 414px)" :srcset="require('@/assets/imgs/product-five/sm-product.png')">
          <source media="(min-width: 415px)" :srcset="require('@/assets/imgs/product-five/product.png')"> -->
          <img class="product-img" :src="require('@/assets/imgs/product-five/product.png')">
        <!-- </picture> -->
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import Arrow from "../Arrow";
import LocalizedLink from '@/components/LocalizedLink'
import {inject} from "vue";

export default {
  name: "SafetyElementPage",
  components: {
    Arrow,
    LocalizedLink
  },
  setup() {
    const store = inject("store");
    return {
      actions: store.actions
    };
  },
  data() {
    return {
      show: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 800);
  }
}
</script>

<style lang="scss" scoped>
.product-detail {
  .detail-inner {
    right: 20%;
    img {
      width: 150%
    }
  }
}
</style>